import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { DataProvider } from './context/DataContext'
import { AuthProvider } from './context/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import Navbar from './components/Navbar'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Customers from './pages/Customers'
import Vehicles from './pages/Vehicles'
import WorkManagement from './pages/WorkManagement'
import Drivers from './pages/Drivers'
import Services from './pages/Services'
import FuelManagement from './pages/FuelManagement'
import Rental from './pages/Rental'

function App() {
  return (
    <AuthProvider>
      <DataProvider>
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <Routes>
            {/* Public Route - Login */}
            <Route path="/login" element={<Login />} />
            
            {/* Protected Routes */}
            <Route path="/*" element={
              <ProtectedRoute>
                <div className="min-h-screen bg-gray-50 flex flex-col">
                  <Navbar />
                  <main className="container mx-auto px-4 py-8 flex-grow">
                    <Routes>
                      <Route path="/" element={<Navigate to="/dashboard" replace />} />
                      <Route path="/dashboard" element={<Dashboard />} />
                      <Route path="/customers" element={<Customers />} />
                      <Route path="/vehicles" element={<Vehicles />} />
                      <Route path="/work" element={<WorkManagement />} />
                      <Route path="/drivers" element={<Drivers />} />
                      <Route path="/services" element={<Services />} />
                      <Route path="/fuel" element={<FuelManagement />} />
                      <Route path="/rental" element={<Rental />} />
                    </Routes>
                  </main>
                  
                  {/* Fixed Footer */}
                  <footer className="bg-orange-100 text-gray-800 py-3 sm:py-4 px-3 sm:px-4 text-center text-xs sm:text-sm border-t border-orange-200">
                    <div className="container mx-auto max-w-7xl">
                      <p className="mb-1 leading-tight">
                        © 2025 Sri Velmurugan Transport and Earthmovers. All rights reserved.
                      </p>
                      <p className="text-gray-600 leading-tight">
                        Designed and developed by <a href="mailto:infothillaitech@gmail.com" className="font-semibold text-red-600 hover:text-red-700 transition-colors duration-200">ThillaiTech</a>
                      </p>
                    </div>
                  </footer>
                </div>
              </ProtectedRoute>
            } />
          </Routes>
        </Router>
      </DataProvider>
    </AuthProvider>
  )
}

export default App
